import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { radius } from '~/styles/tokens/shape';

type PaymentConfirmExitDialogProps = {
  /** Prefixo dos `data-app-id` (reutilizado pelos passos do contrato). */
  appId?: string;
  open: boolean;
  onClose: () => void;
  onConfirmExit: () => void;
  onFillContract: () => void;
};

export default function PaymentConfirmExitDialog({
  appId = 'journey-payment-confirm-exit',
  open,
  onClose,
  onConfirmExit,
  onFillContract
}: PaymentConfirmExitDialogProps) {
  return (
    <Dialog
      aria-describedby={`${appId}-description`}
      aria-labelledby={`${appId}-title`}
      data-app-id={`${appId}-dialog`}
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          borderRadius: `${radius.large}px`,
          maxWidth: 613,
          p: 1,
          width: '100%'
        }
      }}
    >
      <DialogContent
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          px: { md: 6, xs: 3 },
          py: { md: 6, xs: 4 },
          textAlign: 'center'
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'warning.light',
            borderRadius: '100px',
            display: 'flex',
            height: 64,
            justifyContent: 'center',
            width: 64
          }}
        >
          <WarningAmberRoundedIcon
            aria-hidden
            data-app-id={`${appId}-icon`}
            sx={{ color: 'warning.dark', fontSize: 32 }}
          />
        </Box>
        <Typography data-app-id={`${appId}-message`} id={`${appId}-title`} variant="subtitle1">
          Lembre-se de que somente finalizamos a contratação após preencher a próxima etapa.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
          <Button
            data-app-id={`${appId}-fill`}
            fullWidth
            onClick={onFillContract}
            size="large"
            sx={{ borderRadius: `${radius.large}px` }}
            variant="contained"
          >
            Preencher dados
          </Button>
          <Button
            data-app-id={`${appId}-leave`}
            fullWidth
            onClick={onConfirmExit}
            size="large"
            sx={{ borderRadius: `${radius.large}px` }}
            variant="outlined"
          >
            Sair mesmo assim
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
